<script setup lang="ts">
/**
 * Global chrome that belongs to the job platform, not the storefront.
 * Mounting CV/photo sheets on every `/store` page pulled their CSS/JS into
 * the critical path for shoppers who never open them.
 */
import PageLoadingCover from '~/components/app/shared/PageLoadingCover.vue'

const route = useRoute()
const { open: authModalOpen } = useAuthModal()

const routeLoading = useRouteLoading()

const showJobOverlays = computed(() => {
  if (currentStoreSubdomain()) return false
  const path = route.path
  return path === '/'
    || path.startsWith('/app')
    || path.startsWith('/jobs')
    || path.startsWith('/apply')
    || path.startsWith('/hire')
})
</script>

<template>
  <NuxtRouteAnnouncer />
  <NuxtPage />
  <PageLoadingCover v-if="routeLoading" fixed />
  <ClientOnly>
    <template #fallback>
      <span hidden />
    </template>
    <LazyAppSharedPhotoPreview v-if="showJobOverlays" />
    <LazyAppSharedCvPreviewSheet v-if="showJobOverlays" />
    <LazyAppAuthModal v-if="authModalOpen" />
  </ClientOnly>
</template>
